jQuery(document).ready(function () {
    var $ = jQuery;
    $("#menu-toggle-sub").click(function () {
        $("#menu-toggle-sub").toggleClass("toggled-on");
        $("#site-header-sub-menu").toggleClass("toggled-on");
    });
});
